import { Component, ElementRef, HostBinding, Inject, OnDestroy, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { FuseConfigService } from '../core/services/config.service';
import { Platform } from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';
import { AuthDataManager } from '../data/auth.datamanager';
import { Router, ActivatedRoute } from '@angular/router';
import { UsersDataManager } from '../data/users.datamanager';
import { User } from '../data/model/user';
import { FuseNavigationService } from '../core/components/navigation/navigation.service';
import { FuseAdminNavigationModel } from '../navigation/admin.navigation.model';
import { FuseSuperAdminNavigationModel } from '../navigation/superadmin.navigation.model';
import { FuseInstructorNavigationModel } from '../navigation/instructor.navigation.model';

@Component({
    selector     : 'fuse-main',
    templateUrl  : './main.component.html',
    styleUrls    : ['./main.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FuseMainComponent implements OnInit, OnDestroy
{
    onSettingsChanged: Subscription;
    fuseSettings: any;
    @HostBinding('attr.fuse-layout-mode') layoutMode;

    constructor(
        private activatedRoute: ActivatedRoute,
        private authDataManager: AuthDataManager,
        private usersDataManager: UsersDataManager,
        private fuseNavigationService: FuseNavigationService,
        private router: Router,
        private _renderer: Renderer2,
        private _elementRef: ElementRef,
        private fuseConfig: FuseConfigService,
        private platform: Platform,
        @Inject(DOCUMENT) private document: any
    )
    {
        this.onSettingsChanged =
            this.fuseConfig.onSettingsChanged
                .subscribe(
                    (newSettings) => {
                        this.fuseSettings = newSettings;
                        this.layoutMode = this.fuseSettings.layout.mode;
                    }
                );

        if ( this.platform.ANDROID || this.platform.IOS )
        {
            this.document.body.className += ' is-mobile';
        }
    }

    ngOnInit()
    {
        setTimeout(() => this.navigateIfEmpty());
        if (!this.authDataManager.isLoggedIn()){
            this.router.navigate(['/login']);
            return;
        }

        if (this.authDataManager.requiresTwoFactorSetup() && this.router.url !== '/two-factor') {
            this.router.navigate(['/two-factor']);
            return;
        }
        if (this.usersDataManager.getRole() === 'instructor'){
            this.fuseNavigationService.setNavigationModel(new FuseInstructorNavigationModel());
        }
        if (this.usersDataManager.getRole() === 'admin'){
            this.fuseNavigationService.setNavigationModel(new FuseAdminNavigationModel());
        }
        if (this.usersDataManager.getRole() === 'superadmin'){
            this.fuseNavigationService.setNavigationModel(new FuseSuperAdminNavigationModel());
        }
    }

    navigateIfEmpty(){
       if (this.router.url === '/'){
           this.router.navigate([this.authDataManager.requiresTwoFactorSetup() ? '/two-factor' : '/users']);
       }
    }

    ngOnDestroy()
    {
        this.onSettingsChanged.unsubscribe();
    }

    addClass(className: string)
    {
        this._renderer.addClass(this._elementRef.nativeElement, className);
    }

    removeClass(className: string)
    {
        this._renderer.removeClass(this._elementRef.nativeElement, className);
    }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/main.component.ts